let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Bd6A")).then(() => parcelRequire('hOQud'));